"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var KeyInsightsItem_1 = __importDefault(require("components/KeyInsights/KeyInsightsItem"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var calculateKeyInsights_1 = require("utils/calculateKeyInsights");
var ordered_1 = require("utils/selectors/ordered");
var ToolInsights = function (_a) {
    var serviceStatWithExtras = _a.serviceStatWithExtras;
    var recommendations = (0, react_redux_1.useSelector)((0, ordered_1.makeSelectRecommendationsForService)(serviceStatWithExtras.serviceId));
    var keyInsights = (0, calculateKeyInsights_1.getKeyInsightsDataFromReviews)(serviceStatWithExtras, recommendations || [], (serviceStatWithExtras === null || serviceStatWithExtras === void 0 ? void 0 : serviceStatWithExtras.keyInsights) || []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3 }, { children: "Hudled Insights" })), (0, jsx_runtime_1.jsx)("div", { children: keyInsights === null || keyInsights === void 0 ? void 0 : keyInsights.map(function (keyInsightData, idx) { return ((0, jsx_runtime_1.jsx)(KeyInsightsItem_1.default, { order: idx + 1, data: keyInsightData, serviceName: serviceStatWithExtras.service.name }, "".concat(keyInsightData.templateName, "-").concat(serviceStatWithExtras.serviceId))); }) })] }));
};
exports.default = ToolInsights;
